import "./SearchResults.module.css";
import Header from "@/reusable_sections/Header";
import Results from "./sections/Results";
import Footer from "@/reusable_sections/Footer";
export default function SearchResultsPage() {
  return <div>
      <Header />
      <Results />
      <Footer />
    </div>;
}